export default __webpack_public_path__ + "static/media/Latin.9786b44e.mp3";